export default __webpack_public_path__ + "static/media/tab1-image4.46629ecd.png";